angular.module("app.modalControllers").controller("EditPageItemModalController", [
    '$scope',
    '$uibModalInstance',
    'parentPageId',
    'pageId',
    function ($scope, $modalInstance, parentPageId, pageId) {
        $scope.parentId = parentPageId;
        $scope.pageId = pageId;

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
]);